"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CSV = __importStar(require("csv-stringify/browser/esm/sync"));
var date_fns_1 = require("date-fns");
var react_1 = require("react");
var react_redux_firebase_1 = require("react-redux-firebase");
var save_file_1 = __importDefault(require("save-file"));
var useDownloadTransactions = function (companyId, condition) {
    var firebaseInstance = (0, react_redux_firebase_1.useFirebase)();
    var _a = __read((0, react_1.useState)(false), 2), isLoading = _a[0], setIsLoading = _a[1];
    return [
        function () { return __awaiter(void 0, void 0, void 0, function () {
            var transactionsQuerySnapshot, transactions, transactionsWithFormattedDate, headers, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsLoading(true);
                        return [4 /*yield*/, firebaseInstance.firestore()
                                .collection('transactions')
                                .where('companyId', '==', companyId).get()];
                    case 1:
                        transactionsQuerySnapshot = _a.sent();
                        transactions = [];
                        transactionsQuerySnapshot.forEach(function (doc) {
                            if (condition === 'withDocId') {
                                transactions.push([
                                    doc.get('date').toDate(),
                                    doc.id,
                                    doc.get('contactName'),
                                    doc.get('reference'),
                                    doc.get('amount'),
                                    doc.get('subTotal'),
                                    doc.get('total'),
                                    doc.get('currency') || 'AUD',
                                    doc.get('source'),
                                    doc.get('serviceId'),
                                ]);
                            }
                            else if (condition === 'isForG2') {
                                transactions.push([
                                    doc.get('date').toDate(),
                                    doc.get('contactName'),
                                    doc.get('subTotal') || doc.get('amount') || doc.get('total'),
                                    'USD',
                                ]);
                            }
                            else {
                                transactions.push([
                                    doc.get('date').toDate(),
                                    doc.id,
                                    doc.get('contactName'),
                                    doc.get('reference'),
                                    doc.get('amount'),
                                    doc.get('subTotal'),
                                    doc.get('total'),
                                    doc.get('currency') || 'AUD',
                                    doc.get('source'),
                                    doc.get('serviceId'),
                                ]);
                            }
                        });
                        transactions.sort(function (a, b) { return +a[0] - +b[0]; });
                        transactionsWithFormattedDate = transactions
                            .map(function (_a) {
                            var _b = __read(_a), date = _b[0], rest = _b.slice(1);
                            return __spreadArray([(0, date_fns_1.format)(date, 'yyyy-MM-dd')], __read(rest), false);
                        });
                        headers = condition === 'isForG2'
                            ? ['Date', 'Description', 'Amount', 'Currency']
                            : ['date', 'id', 'contactName', 'reference', 'amount', 'subTotal', 'total', 'currency', 'source', 'serviceId'];
                        data = CSV.stringify(__spreadArray([headers], __read(transactionsWithFormattedDate), false));
                        (0, save_file_1.default)(data, 'transactions.csv');
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        }); },
        isLoading,
    ];
};
exports.default = useDownloadTransactions;
